import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5102af4&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=c5102af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5102af4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxButtonOutlined: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Outlined.vue').default,IxSubSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSectionTitle.vue').default,IxSubSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSectionText.vue').default,IxSubSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSection.vue').default})
